
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import lazyInject from '@/di';
import OrderService from '@/services/order.service';

@Component({})
export default class BaseScreenBIPage extends Vue {
  @lazyInject(OrderService)
  orderService!: OrderService;

  @Prop()
  title!: string;

  @Prop()
  baseSrc!: string;

  @Prop()
  pageData!: string;

  src = '';

  created() {
    this.init();
  }

  @Watch('baseSrc')
  async init() {
    // console.log(this.pageData, this.pageData.indexOf('&param'));
    let worksId = this.pageData;
    if (this.pageData.indexOf('&param') !== -1) {
      worksId = this.pageData.split('&param')[0];
    }
    const data = {
      worksId,
    };
    const token = await this.orderService.BIToken(data);
    if (!token) {
      return;
    }
    this.src = `${this.baseSrc}&accessTicket=${token}`;
  }
}
